module.exports = __webpack_public_path__ + "img/4-3.2a82d1e4.png";